import { useUpdateSectionMAMutation } from 'store/slices/layoutsMA/apis/materialAssessmentApi';

import type { SectionMAStatusValue } from 'store/slices/layoutsMA/interfaces/ISectionMAType';
import type IUseUpdateStatusSection from './interfaces/IUseUpdateStatusSection';

const useUpdateStatusSection = ({
  recordId,
  type,
  active,
  status,
}: IUseUpdateStatusSection) => {
  const [updateSection] = useUpdateSectionMAMutation();

  const updateStatus = (nextStatus?: SectionMAStatusValue) => {
    if (!recordId) return;
    updateSection({
      maId: recordId,
      type,
      data: {
        isActive: active ?? false,
        status: nextStatus ?? status,
      },
    });
  };
  return {
    updateStatus,
  };
};

export default useUpdateStatusSection;
